<template>
  <div>
    <div class="back">
      <div class="bodyBox">
        <div class="tab" @click="loginType = 1">账号登录</div>
        <div class="typeCont">
          <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-form-item prop="code" label="登录账号">
              <el-input
                v-model="form.code"
                placeholder="请输入企业社会信用代码"
              >
              </el-input>
            </el-form-item>
            <el-form-item prop="password" label="登录密码">
              <el-input
                v-model="form.password"
                placeholder="请输入登录密码"
                type="password"
              >
              </el-input>
            </el-form-item>
            <div style="display: flex; align-items: flex-end">
              <el-form-item prop="captcha" label="验证码" style="width: 70%">
                <el-input v-model="form.captcha" placeholder="请输入验证码">
                </el-input>
              </el-form-item>
              <span class="codeControll"><imgVerify /></span>
            </div>
          </el-form>
          <el-button class="loginBtn" @click="loginBtn">登 录</el-button>
          <div class="help">
            <div class="register" @click="registerBtn">注册账号</div>
            <div class="psw" @click="forgetpswBtn">忘记密码？</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import { login } from "@/api/index.js";
import imgVerify from "@/components/common/imgVerify";
import { mapGetters, mapState } from "vuex";

export default {
  name: "login",
  components: {
    imgVerify,
  },
  data() {
    return {
      loginType: 1, // 登录方式1密码2短信
      // 密码登录
      form: {
        code: "", //信用代码
        password: "", // 密码
        captcha: "", // 验证码
      },
      rules: {
        code: [
          {
            required: true,
            message: "请输入企业社会信用代码",
            trigger: "blur",
          },
        ],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "密码长度在6-20位之间",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["skk_img_ca_session"]),
    ...mapState(["userinfo"]),
  },
  created() {},
  mounted() {
    // axios.post("https://yapi.rxxcy.com/mock/11/api/common/getClause", {
    //   test1: 1,
    //   test2: 2,
    // });
  },
  methods: {
    registerBtn() {
      this.$router.push({ name: "register" });
    },
    //忘记密码
    forgetpswBtn() {
      this.$router.push({
        name: "password",
      });
    },
    // 点击登录按钮
    loginBtn() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (!this.skk_img_ca_session) {
            this.$message.error("验证失效,请刷新页面");
            return false;
          }
          const params = {
            ...this.form,
            skk_session: this.skk_img_ca_session,
          };
          const userinfo = await login(params);
          // console.log(userinfo, "userinfo");
          //登记须知读未读，返回的是true和false，但要存storage里面，就成字符串了
          // 所以这里转成数字存储，true转数字为1，false 转数字为0，
          //后面其他地方逻辑用1 和 0 判断读未读
          // localStorage.setItem(
          //   "skk_is_read_arg",
          //   Number(userinfo.company_info.is_look_agre)
          // );
          this.$message.success("登录成功！");
          this.$store.commit("setUserInfo", userinfo);

          // console.log(
          //   this.userinfo.is_set_password,
          //   "this.userinfo.is_set_password"
          // );
          // console.log(
          //   this.userinfo.company_info.phone,
          //   "this.userinfo.company_info.phone"
          // );
          // console.log(this.userinfo.phone, "this.userinfo.phone");
          //新用户
          if (this.userinfo.is_set_password) {
            this.$router.push({ name: "homeIndex" });
          } else {
            // 老用户
            this.$router.push({ name: "setAccount" });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.back {
  background-image: url("~@/assets/img/login_back.png");
  height: 720px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 110px;

  .bodyBox {
    position: relative;
    width: 460px;
    margin: auto;
    background: #ffffff;
    border-radius: 2px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.2);
    padding: 57px 40px 72px;
    box-sizing: border-box;

    .scan {
      position: absolute;
      top: 0;
      right: 0;
      width: 41px;
      height: 41px;
    }

    .tab {
      font-size: 24px;
      font-weight: 700;
      text-align: center;
      color: #333333;
      display: flex;
      justify-content: center;
    }

    .typeCont {
      margin-top: 39px;

      /deep/ .el-input__icon {
        width: 42px;
      }

      /deep/ .el-input--prefix .el-input__inner {
        padding-left: 42px;
        background: #f6f6f6;
        border: 1px solid #f6f6f6;
      }

      /deep/
        .el-form-item.is-required:not(.is-no-asterisk)
        > .el-form-item__label:before {
        color: #fff;
        margin-right: unset;
        content: "";
      }

      /deep/ .el-form-item__label {
        line-height: unset;
        margin-bottom: 10px;
      }

      .codeControll {
        margin-left: 11px;
        width: 100px;
        height: 40px;
        margin-bottom: 22px;
      }
    }

    .loginBtn {
      width: 100%;
      height: 45px;
      background: #4379f6;
      border-radius: 2px;
      box-shadow: 0px 3px 6px 0px rgba(67, 121, 246, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular, sans-serif;
      color: #fff;
      margin-top: 10px;
      transition: all 0.3s;

      &:hover {
        background: #316bf1;
      }
    }

    .help {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 15px;

      .psw {
        min-width: 70px;
        border: 1px solid rgba(0, 0, 0, 0);
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular, sans-serif;
        color: #999;
        cursor: pointer;
      }

      .register {
        min-width: 56px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular, sans-serif;
        color: #2f60ed;
        cursor: pointer;
      }
    }

    .letter {
      padding-top: 41px;
      display: flex;
      justify-content: center;
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-Regular, sans-serif;
      color: #999;
    }

    .scanLogin {
      width: 190px;
      height: 190px;
      background: #ddd;
      margin: auto;
      margin-top: 27px;
    }

    .goCont {
      width: 100%;
      display: flex;
      justify-content: center;

      .goRegister {
        margin-top: 35px;
        width: 56px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular, sans-serif;
        color: #2f60ed;
        cursor: pointer;
      }
    }
  }
}
</style>
